const theme = {
  dark: false,
  colors: {
    primary: "rgba(162, 176, 49, 1)",
    background: "rgb(242, 242, 242)",
    card: "rgb(255, 255, 255)",
    text: "rgb(0, 0, 0)",
    notification: "rgba(162, 176, 49, 0.42)",
  },
};

export default theme;
